"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGMVariation = void 0;
const getGMVariation = (item) => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.variations) === null || _a === void 0 ? void 0 : _a.find((variation) => variation.varType === 'gm'); };
exports.getGMVariation = getGMVariation;
